<p>{{ 'DIALOG.EDIT_ROWS.COLUMN.TITLE' | translate}}</p>
<tilby-magic-form class="sass"
          [allFieldWidth]="allWithCheckbox?'100%':'auto'"
          [allWithCheckbox]="allWithCheckbox"
          [form]="data.form"
></tilby-magic-form>

